import { render, staticRenderFns } from "./app-vehicle-block.vue?vue&type=template&id=72bc1110&scoped=true"
import script from "./app-vehicle-block.vue?vue&type=script&lang=js"
export * from "./app-vehicle-block.vue?vue&type=script&lang=js"
import style0 from "./app-vehicle-block.vue?vue&type=style&index=0&id=72bc1110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc1110",
  null
  
)

export default component.exports